export const RegistrarInterface = {
  NombreCompleto: '',
  idResponsabilidad: '',
  Ubicacion: '',
  imageName: '',
  files: [
    {
      file: '',
    },
  ],
};

export const BannerInterface = {
  title: '',
  description: '',
  files: [
    {
      file: '',
    },
  ],
  socialNetworks: [],
};

export const socialNetworksInterface = {
  socialNetworksLink: "",
  socialNetworksType: "",
  textButton: ""
};

export const GalleryInterface = {
  idEvento: 0,
  files: [
  ],
};

